import { createAction, makeActionTrackable } from '@lingoda/core';

interface Credentials {
    username: string;
    password: string;
    rememberMe: boolean;
    token?: string;
}

export default makeActionTrackable(createAction<Credentials>('auth/LOGIN'));
